import React from "react";
import { Ticket, X } from "lucide-react";

const chip = (on) => `shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-sm font-medium border transition-colors ${on ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "bg-white/5 border-white/10 text-[#E8E4F0] hover:border-white/25"}`;

export const MemberTicketFilter = ({ groups, group, pkg, status, onGroup, onPkg, onStatus, onClear }) => {
  const g = groups.find((x) => x.key === group);
  return (
    <div className="mb-4 rounded-2xl bg-white/[0.03] border border-white/10 p-3" data-testid="ticket-filter">
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-[#A19DB0] whitespace-nowrap"><Ticket size={13} /> Tickets</p>
        {group && <button onClick={onClear} data-testid="ticket-filter-clear" className="ml-auto inline-flex items-center gap-1 text-xs text-[#A19DB0] hover:text-white px-2"><X size={13} /> Clear</button>}
        <div className="flex items-center gap-1 bg-white/5 rounded-full p-0.5" data-testid="ticket-status-toggle">
          {[["active", "Active"], ["all", "All"]].map(([k, l]) => (
            <button key={k} onClick={() => onStatus(k)} data-testid={`ticket-status-${k}`} className={`rounded-full px-2.5 py-1 text-xs transition-colors ${status === k ? "bg-white/15 text-white" : "text-[#A19DB0]"}`} title={k === "all" ? "Include used and expired passes" : "Unused, not expired"}>{l}</button>
          ))}
        </div>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1" data-testid="ticket-group-chips">
        {groups.map((x) => (
          <button key={x.key} onClick={() => onGroup(group === x.key ? "" : x.key)} data-testid={`ticket-group-${x.key}`} className={chip(group === x.key && !pkg)}>
            {x.name} passes <span className="opacity-70">({x.member_count})</span>
          </button>
        ))}
      </div>
      {g && g.packages.length > 0 && (
        <div className="flex gap-2 overflow-x-auto mt-2 pt-2 border-t border-white/5" data-testid="ticket-package-chips">
          {g.packages.map((p) => (
            <button key={p.id} onClick={() => onPkg(pkg === p.id ? "" : p.id)} data-testid={`ticket-package-${p.id}`} className={chip(pkg === p.id)}>
              <span className="w-2 h-2 rounded-full" style={{ background: p.color || "#9D4EDD" }} />
              {p.name}{p.active === false ? " (inactive)" : ""} <span className="opacity-70">({p.member_count})</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
